<template>
  <nav class='site-map'>
    <header>
      <h1>Карта сайта</h1>
      <router-link
        to="/"
        class="section header"
      >
        <span>Главная страница</span>
        <svg-sprite-icon
          class="logo"
          v-bind:src="'logo-mini'"
        ></svg-sprite-icon>
      </router-link>
    </header>
    <ul class='sections'>
      <li
        v-for="section in navigation"
        v-bind:key="section.alias"
      >
        <router-link
          v-bind:to="`/${section.alias}`"
          class="section"
        ><!--
       -->{{ section.title }}<!--
     --></router-link>
        <ul
          class="categories"
          v-if="hasCategories(section)"
        >
          <li
            v-for="category in section.categories"
            v-bind:key="category.alias"
          >
            <router-link
              v-bind:to="`/${section.alias}/${category.alias}`"
            ><!--
           -->{{ category.title }}<!--
         --></router-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import SvgSpriteIcon from '@/components/utils/SvgSpriteIcon'

export default {
  name: 'SiteMapPage',
  components: { SvgSpriteIcon },
  data: function () {
    return {
      navigation: {}
    }
  },
  metaInfo: {
    title: 'Карта сайта',
    meta: [
      {
        name: 'description',
        content:
          'Ссылки на основные страницы сайта ювелирной фирмы «Стиль»: ' +
          'каталог золотых и серебряных украшений, ремонт ювелирных изделий ' +
          'информация о компании и контактная информация.'
      }
    ]
  },
  mounted () {
    const uriParams = {params: {verbose: true}}
    this.$http
      .get(`${process.env.API_HOST}/api/v1/site-structure/get-menu`, uriParams)
      .then(response => { this.navigation = response.body })
  },
  updated () {
    if (Object.keys(this.navigation).length > 0 &&
        window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  methods: {
    hasCategories: function (section) {
      return section.categories && (section.categories.length > 0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .site-map {
    @include page-block-vertical-padding();
    font-family: "Gotham Pro Regular", $font-stack;
    @include media(">tablet") { font-size: 14px; };
    @include media("<=tablet") { font-size: 16px; };
    h1 {
      color: $default-link-color;
      margin-bottom: 1.5em;
      &:after {
        content: "";
        display: block;
        margin: 0.5em auto 0 auto;
        width: 50px;
        height: 2px;
        background-color: $default-heading-color;
      }
    }
    a {
      text-decoration: none;
    }
    .section {
      text-transform: uppercase;
      letter-spacing: 0.2em;
      display: inline-block;
      margin-bottom: 1em;
      &.header {
        margin-bottom: 0;
        & > .logo {
          fill-rule: evenodd;
          fill: $default-link-color !important;
          display: block;
          height: 1.25em;
          margin: 1em auto 0 auto;
        }
      }
    }
    & > .sections {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 0;
      line-height: 1.33;

      & > li {
        flex: 0 0 auto;
        margin: 0;
        padding: 2em 1em 0 1em;
        box-sizing: border-box;
        text-align: left;
        max-width: 320px;
        @include media ("<=mobile") {
          width: calc(100% - 2em);
        }

        & > .categories {
          a {
            color: $default-text-color;
            &:hover { color: $default-link-color; }
          }
          & > li {
            display: block;
            margin: 0;
            text-align: left;
            margin-bottom: 0.75em;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/SiteMapPage.vue